export const CUSTOMERS_CURRENT_ENDPOINT = '/c/v1/customers/current';
export const CURRENT_CUSTOMERS_CONTEXT_ENDPOINT =
  '/c/v1/chat/customers/current';
